import React from 'react';
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";

import { isIPhone } from "@/modules/iOSDetection";
import { mouseOver, mouseLeave } from "@/modules/mouseInteractions";
import { rouletteReds, betGroupProp, getWinClassName } from "@/modules/commonMobile";
import { IGameTableType } from "@/types/GlobalTypes";

import nary from "@/modules/nary";
import nth0 from "@/modules/nth0";
import zeroFill from "@/modules/zeroFill";
import Nnary from "@/modules/Nnary";

//Roulette
export default class Portrait extends React.Component<IGameTableType> {
    render() {
		const { langdata } = this.props;

		const win = this.props.win ? Number(this.props.win) : null;
		const reds = rouletteReds;

		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
        };
        
        const bets = [
            ["1 to 18", "19 to 36"],
            ["odd", "even"],
            ["red", "black"]
        ]; //paired with betGroup

        const betLabels = [
            ["1-18", "19-36"],
            [langdata["txt_odd"], langdata["txt_even"]],
            [langdata["txt_red"], langdata["txt_black"]]
        ];

        const wins = [
            [(win && win > 0 && win <= 18), (win && win >= 19 && win <= 36)],
            [(win && win % 2 > 0), win && !(win % 2) && win > 0],
            [(win && reds.indexOf(Number(win)) >= 0), (win && reds.indexOf(Number(win)) < 0)]
        ];


        return (
        <div className="sl-table">
            {
                bets.map((row, rowIdx) =>
                    <div key={"p7_row_bet_" + rowIdx} className="row">
                    {
                        row.map((cell, cellIdx) =>
                            <div className={
                                    "sl-bet col-xs-6" +
                                    (
                                        cell === "red" ? " sl-red-lighten" :
                                        cell === "black" ? " sl-black-lighten" :
                                        " sl-green-old"
                                    ) +
                                    getWinClassName(wins[rowIdx][cellIdx])
                                }

                                key={"p7_" + cell + "_" + cellIdx}
                                {...betGroupProp(this, cell, "n50")}

                                onClick={this.props.insertBet}>
                                {betLabels[rowIdx][cellIdx]}
                            <Chips {...commonChipProps} betKey={`${cell}+n50`} />
                            </div>   
                        )
                    }
                    </div>
                )
            }

            {
                // <div className="row">
                //     <div className={"sl-bet col-xs-6 sl-green-old" + ((win && win > 0 && win <= 18) ? " sl-yellow-alternating" : "")}
                //         {...betGroupProp(this, "1 to 18", "n50")}
                //         onClick={this.props.insertBet}>
                //         1-18
                //     <Chips {...commonChipProps} betKey="1 to 18+n50" />
                //     </div>
                //     <div className={"sl-bet col-xs-6 sl-green-old" + ((win && win >= 19 && win <= 36) ? " sl-yellow-alternating" : "")}
                //         {...betGroupProp(this, "19 to 36", "n50")}
                //         onClick={this.props.insertBet}>
                //         19-36
                //     <Chips {...commonChipProps} betKey="19 to 36+n50" />
                //     </div>
                // </div>
                // <div className="row">
                //     <div className={"sl-bet col-xs-6 sl-green-old" + ((win % 2) ? " sl-yellow-alternating" : "")}
                //         {...betGroupProp(this, "odd", "n50")}
                //         onClick={this.props.insertBet}>
                //         {langdata["txt_odd"]}
                //         <Chips {...commonChipProps} betKey="odd+n50" />
                //     </div>
                //     <div className={"sl-bet col-xs-6 sl-green-old" + (win && !(win % 2) && win > 0 ? " sl-yellow-alternating" : "")}
                //         {...betGroupProp(this, "even", "n50")}
                //         onClick={this.props.insertBet}>
                //         {langdata["txt_even"]}
                //         <Chips {...commonChipProps} betKey="even+n50" />
                //     </div>
                // </div>
                // <div className="row">
                //     <div className={"sl-bet col-xs-6 sl-red-lighten" + ((reds.indexOf(Number(win)) >= 0) ? " sl-yellow-alternating" : "")}
                //         {...betGroupProp(this, "red", "n50")}
                //         onClick={this.props.insertBet}>
                //         {langdata["txt_red"]}
                //         <Chips {...commonChipProps} betKey="red+n50" />
                //     </div>
                //     <div className={"sl-bet col-xs-6 sl-black-lighten" + ((reds.indexOf(Number(win)) < 0 && win > 0) ? " sl-yellow-alternating" : "")}
                //         {...betGroupProp(this, "black", "n50")}
                //         onClick={this.props.insertBet}>
                //         {langdata["txt_black"]}
                //         <Chips {...commonChipProps} betKey="black+n50" />
                //     </div>
                // </div>
            }

            <div className={"sl-bet col-xs-12 sl-green-lighten" +
                (win === 0 ? " sl-yellow-alternating" : "")}
                {...betGroupProp(this, "00", "n")}
                onClick={this.props.insertBet}>
                0
              <Chips {...commonChipProps} betKey="00+n" />
            </div>

            <div className="row sl-green-old">
                {
                    nary(3).map((num, numIdx) =>
                        <div key={"p7_2to1_" + numIdx}
                            className={"sl-bet col-xs-3 sl-green-old" +
                                (win && (win % 3 === num % 3) ? " sl-yellow-alternating" : "")}
                            {...betGroupProp(this, nth0(numIdx) + " Row", "n12")}

                            onClick={this.props.insertBet}>
                            {langdata["txt_2_to_1"]}
                            <Chips {...commonChipProps}
                                //betKey="1st Row+n12"
                                betKey={nth0(numIdx) + " Row+n12"}
                                />
                        </div>
                    )
                }
            </div>


            <div className="row">
                <div className={"sl-bet col-xs-3 sl-green-old p7-tall" + (win >= 1 && win <= 12 ? " sl-yellow-alternating" : "")}
                    {...betGroupProp(this, "1st 12", "n12")}
                    onClick={this.props.insertBet}>
                    1st 12
                  <Chips {...commonChipProps} betKey="1st 12+n12" />
                </div>

                {
                    nary(12).map(num => zeroFill(num, 2)).map(num =>
                        <div className={"sl-bet col-xs-3 " + (reds.indexOf(Number(num)) >= 0 ? "sl-red-lighten" : "sl-black-lighten")
                            + (win === +num ? " sl-yellow-alternating" : "")}
                            key={"portrait" + num + "+n"}
                            {...betGroupProp(this, num, "n")}
                            onClick={this.props.insertBet}>
                            {num}
                            <Chips {...commonChipProps} betKey={num + "+n"} />
                        </div>
                    )
                }
            </div>


            <div className="row">
                <div className={"sl-bet col-xs-3 sl-green-old p7-tall" + ((win >= 13 && win <= 24) ? " sl-yellow-alternating" : "")}
                    {...betGroupProp(this, "2nd 12", "n12")}
                    onClick={this.props.insertBet}>
                    2nd 12
                <Chips {...commonChipProps} betKey="2nd 12+n12" />
                </div>
                {
                    Nnary(13, 24).map(num =>
                        <div className={"sl-bet col-xs-3 " + (reds.indexOf(Number(num)) >= 0 ? "sl-red-lighten" : "sl-black-lighten")
                            + (win === +num ? " sl-yellow-alternating" : "")}
                            key={num + "+n"}
                            {...betGroupProp(this, num + "", "n")}
                            onClick={this.props.insertBet}>
                            {num}
                            <Chips {...commonChipProps} betKey={num + "+n"} />
                        </div>
                    )
                }
            </div>


            <div className="row">
                <div className={"sl-bet col-xs-3 sl-green-old p7-tall" + ((win >= 25 && win <= 36) ? " sl-yellow-alternating" : "")}
                    {...betGroupProp(this, "3rd 12", "n12")}
                    onClick={this.props.insertBet}>
                    3rd 12
                <Chips {...commonChipProps} betKey="3rd 12+n12" />
                </div>
                {
                    Nnary(25, 36).map(num =>
                        <div className={"sl-bet col-xs-3 " + (reds.indexOf(Number(num)) >= 0 ? "sl-red-lighten" : "sl-black-lighten")
                            + (win === +num ? " sl-yellow-alternating" : "")}
                            key={num + "+n"}
                            {...betGroupProp(this, num + "", "n")}
                            onClick={this.props.insertBet}>
                            {num}
                            <Chips {...commonChipProps} betKey={num + "+n"} />
                        </div>
                    )
                }
            </div>


            {
                // Mobile portrait multibet starts here
            }
            {
                [["01,04", "02,05", "03,06"],
                ["04,07", "05,08", "06,09"],
                ["07,10", "08,11", "09,12"],
                ["10,13", "11,14", "12,15"],
                ["13,16", "14,17", "15,18"],
                ["16,19", "17,20", "18,21"],
                ["19,22", "20,23", "21,24"],
                ["22,25", "23,26", "24,27"],
                ["25,28", "26,29", "27,30"],
                ["28,31", "29,32", "30,33"],
                ["31,34", "32,35", "33,36"]].map((row, rowIdx) =>
                    row.map((groupComma, groupIdx) => {
                        const firstPercent = -0.5;
                        const leftSpace = 25;

                        return <div className={"sl-bet col-xs-3 hidden"}
                            key={groupComma + "+n2"}
                            style={{
                                position: "absolute",
                                left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "%)",
                                top: "calc(33% + " + (rowIdx * 6) + "vh)",

                                border: "none",
                                height: "4vh"
                            }}>
                            <Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
                            <Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
                            <div className="sl-hover-hidden"
                                {...betGroupProp(this, groupComma, "n2")}
                                onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
                        </div>;
                    })
                )
            }

            {
                [["01,02", "02,03"],
                ["04,05", "05,06"],
                ["07,08", "08,09"],
                ["10,11", "11,12"],
                ["13,14", "14,15"],
                ["16,17", "17,18"],
                ["19,20", "20,21"],
                ["22,23", "23,24"],
                ["25,26", "26,27"],
                ["28,29", "29,30"],
                ["31,32", "32,33"],
                ["34,35", "35,36"]].map((row, rowIdx) =>
                    row.map((groupComma, groupIdx) => {
                        const firstPercent = 20.5;
                        const leftSpace = 25;

                        return <div className={"sl-bet col-xs-1 hidden"}
                            key={groupComma + "+n2"}
                            style={{
                                position: "absolute",
                                left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "%)",
                                top: "calc(30% + " + (rowIdx * 6) + "vh)",
                                border: "none",
                                height: "4vh"
                            }}>
                            <Chips between={true} {...commonChipProps} betKey={groupComma + "+n2"} />
                            <Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n2"]} />
                            <div className="sl-hover-hidden"
                                {...betGroupProp(this, groupComma, "n2")}
                                onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
                        </div>;
                    })
                )
            }

            {
                [["01,02,04,05", "02,03,05,06"],
                ["04,05,07,08", "05,06,08,09"],
                ["07,08,10,11", "08,09,11,12"],
                ["10,11,13,14", "11,12,14,15"],
                ["13,14,16,17", "14,15,17,18"],
                ["16,17,19,20", "17,18,20,21"],
                ["19,20,22,23", "20,21,23,24"],
                ["22,23,25,26", "23,24,26,27"],
                ["25,26,28,29", "26,27,29,30"],
                ["28,29,31,32", "29,30,32,33"],
                ["31,32,34,35", "32,33,35,36"]].map((row, rowIdx) =>
                    row.map((groupComma, groupIdx) => {
                        const firstPercent = 20.5;
                        const leftSpace = 25;

                        return <div className={"sl-bet col-xs-1 hidden"}
                            key={groupComma + "+n4"}
                            style={{
                                position: "absolute",
                                left: "calc(" + firstPercent + "% + " + (groupIdx * leftSpace) + "%)",
                                top: "calc(33% + " + (rowIdx * 6) + "vh)",
                                border: "none",
                                height: "3vh"
                            }}>
                            <Chips between={true} {...commonChipProps} betKey={groupComma + "+n4"} />
                            <Tooltip {...commonTooltipProps} bet={this.props.bets[groupComma + "+n4"]} />
                            <div className="sl-hover-hidden"
                                {...betGroupProp(this, groupComma, "n4")}
                                onClick={this.props.insertBet} onMouseLeave={!isIPhone() ? mouseLeave.bind(this) : undefined} onMouseOver={!isIPhone() ? mouseOver.bind(this) : undefined}></div>
                        </div>;
                    })
                )
            }
        </div>
        // END OF MOBILE PORTRAIT
        );
    }
}